// src/components/admin/TorreDeControl/modals/PaymentsModal.jsx
import React, { useState, useEffect } from 'react';
import { X, DollarSign } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

function PaymentsModal({ item, onClose, onUpdate }) {
  const [formData, setFormData] = useState({
    charge: '',
    charged: '',
    fastmax_transfer_amount: '',
    provider_transfer_amount: '',
    fastmax_exchange_amount: '',
    quince_soles: false,
    veinte_soles: false,
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (item) {
      setFormData({
        charge: item.charge || '',
        charged: item.charged || '',
        fastmax_transfer_amount: item.fastmax_transfer_amount || '',
        provider_transfer_amount: item.provider_transfer_amount || '',
        fastmax_exchange_amount: item.fastmax_exchange_amount || '',
        quince_soles: item.quince_soles || false,
        veinte_soles: item.veinte_soles || false,
      });
    }
  }, [item]);

  async function handleSubmit(e) {
    e.preventDefault();
    setIsLoading(true);

    try {
      await axios.put(`${API_URL}/api/admin/delivery-point/${item.id}/payments`, formData);
      onUpdate();
      onClose();
    } catch (error) {
      console.error('Error updating payments:', error);
      alert('Error al actualizar pagos');
    } finally {
      setIsLoading(false);
    }
  }

  function handleChange(e) {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  }

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[10000] p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="bg-[#B1336E] px-6 py-4 flex items-center justify-between">
          <h3 className="text-white font-bold text-lg flex items-center gap-2 font-montserrat">
            <DollarSign className="w-5 h-5" />
            Actualizar Pagos
          </h3>
          <button
            onClick={onClose}
            className="text-white hover:bg-white/20 p-2 rounded-lg transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2 font-montserrat">
              Cargo (S/)
            </label>
            <input
              type="number"
              step="0.01"
              name="charge"
              value={formData.charge}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#B1336E]/20 focus:border-[#B1336E] font-montserrat"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2 font-montserrat">
              Cobrado (S/)
            </label>
            <input
              type="number"
              step="0.01"
              name="charged"
              value={formData.charged}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#B1336E]/20 focus:border-[#B1336E] font-montserrat"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2 font-montserrat">
              Transfer Fast Max (S/)
            </label>
            <input
              type="number"
              step="0.01"
              name="fastmax_transfer_amount"
              value={formData.fastmax_transfer_amount}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#B1336E]/20 focus:border-[#B1336E] font-montserrat"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2 font-montserrat">
              Transfer Proveedor (S/)
            </label>
            <input
              type="number"
              step="0.01"
              name="provider_transfer_amount"
              value={formData.provider_transfer_amount}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#B1336E]/20 focus:border-[#B1336E] font-montserrat"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2 font-montserrat">
              Vuelto Fast Max (S/)
            </label>
            <input
              type="number"
              step="0.01"
              name="fastmax_exchange_amount"
              value={formData.fastmax_exchange_amount}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-[#B1336E]/20 focus:border-[#B1336E] font-montserrat"
            />
          </div>

          <div className="space-y-3 bg-slate-50 p-4 rounded-lg">
            <label className="flex items-center gap-3 cursor-pointer">
              <input
                type="checkbox"
                name="quince_soles"
                checked={formData.quince_soles}
                onChange={handleChange}
                className="w-5 h-5 text-[#B1336E] border-slate-300 rounded focus:ring-2 focus:ring-[#B1336E]/20"
              />
              <span className="text-sm font-medium text-slate-700 font-montserrat">
                15 Soles
              </span>
            </label>

            <label className="flex items-center gap-3 cursor-pointer">
              <input
                type="checkbox"
                name="veinte_soles"
                checked={formData.veinte_soles}
                onChange={handleChange}
                className="w-5 h-5 text-[#B1336E] border-slate-300 rounded focus:ring-2 focus:ring-[#B1336E]/20"
              />
              <span className="text-sm font-medium text-slate-700 font-montserrat">
                20 Soles
              </span>
            </label>
          </div>

          <div className="flex gap-3 pt-4 border-t border-slate-200">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 bg-slate-200 hover:bg-slate-300 text-slate-700 px-4 py-2 rounded-lg font-medium transition-colors font-montserrat"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={isLoading}
              className="flex-1 bg-[#B1336E] hover:bg-[#B1336E]/90 disabled:bg-slate-300 text-white px-4 py-2 rounded-lg font-medium transition-colors font-montserrat"
            >
              {isLoading ? 'Guardando...' : 'Guardar Cambios'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default PaymentsModal;